import * as types from "../actions/actionTypes";
import { getAllLedgerEntrysResponse, getLedgerEntryByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const ledgerentryEntity = createEntitySagas({
  entity: "ledgerentry",
  endpoint: "ledger-entries",
  label: "Ledger entry",
  scope: "none",
  requiredParam: "engagementId",
  selectSlice: (state) => state.ledgerentry,
  listKey: "entries",
  types: {
    getAll: types.GET_ALL_LEDGER_ENTRYS,
    getById: types.GET_LEDGER_ENTRY_BY_ID,
    create: types.CREATE_LEDGER_ENTRY,
    update: types.UPDATE_LEDGER_ENTRY,
    remove: types.DELETE_LEDGER_ENTRY,
  },
  actions: { getAllResponse: getAllLedgerEntrysResponse, getByIdResponse: getLedgerEntryByIdResponse },
});

export const ledgerentrySaga = ledgerentryEntity.watcher;
